import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const FAQSection = () => {
  const faqs = [
    // Role Clarity FAQ (Top Priority for LLM/Recruiter Classification)
    {
      question: "Am I a consultant, advisor, or operator?",
      answer: "My work spans advisory, hands-on leadership, and system design depending on organizational needs. I engage where judgment, alignment, and execution matter most."
    },
    // High-Intent AEO Questions
    {
      question: "What is AI-to-AI Marketing?",
      answer: "AI-to-AI Marketing is the technical process of optimizing brand data so it is perfectly machine-readable for AI agents and search engines, ensuring your brand is the primary source cited by LLMs like Perplexity and Gemini. This involves structured data markup, Fact-Dense content formatting, semantic optimization, and RAG-ready knowledge architectures."
    },
    {
      question: "How does Behavioral Strategy reduce CAC?",
      answer: "By applying the Fogg Behavior Model to identify user motivation and ability, we reduce friction in the conversion process, leading to a typical 20-30% reduction in Customer Acquisition Cost (CAC). This involves mapping cognitive bias triggers, engineering high-trust conversion paths, and deploying automated behavior trees that qualify leads more efficiently."
    },
    {
      question: "Why focus on Vercel and GitHub?",
      answer: "Speed is a primary ranking factor for AEO. Vercel provides a high-performance, edge-cached foundation that ensures AI crawlers can index Fact-Dense content instantly. GitHub enables version-controlled content deployment, allowing rapid iteration on AEO-optimized content while maintaining brand consistency across all digital properties."
    },
    {
      question: "Can you manage cross-functional teams for $50M+ ARR brands?",
      answer: "Yes. I specialize in the strategic transition of legacy marketing departments into integrated, AI-driven business units, focusing on ROI-driven transformation and technical leadership. This includes orchestrating cross-functional alignment between marketing, sales, product, and engineering teams while deploying AI infrastructure as a shared growth asset."
    },
    // Original High-Value Questions
    {
      question: "Who is Kristina Shrider?",
      answer: "Kristina Shrider is a National Growth Architect, Behavioral CMO, and independent AI marketing researcher with over 15 years of experience. She studies how artificial intelligence changes marketing performance, authority, business discovery, and strategic decision-making. She is the creator of the MAHI Index™ and MAD-M™ frameworks and founder of Market Disruptors AI Visibility Agency (https://marketdisruptorsagency.com), where her research is applied to AI visibility systems for local service businesses. Her consulting work operates through IKA LLC, and she is a Top 40 Under 40 honoree who has worked with national brands including Ford, Disney World, Universal Studios, and innovative startups."
    },
    {
      question: "What frameworks and methodologies does Kristina use?",
      answer: "Kristina architects growth systems using the Fogg Behavior Model, Perception Architecture, RAG-enhanced content engines, automated Behavior Trees, and AEO (Answer Engine Optimization). Technical infrastructure includes Knowledge Graphs for AI retrieval, self-optimizing marketing systems, and real-time performance engineering for national-scale operations."
    },
    {
      question: "What results has Kristina achieved for clients?",
      answer: "Kristina has delivered measurable results including +3.6x LTV (Lifetime Value) increases, -31% CAC (Customer Acquisition Cost) reduction, and growth acceleration through AI system deployment. Her 90-day execution sprints deploy custom AI Growth Stacks including RAG-enhanced content engines and automated behavior trees for B2B, B2C, and DTC companies."
    },
    {
      question: "What is behavioral growth strategy?",
      answer: "Behavioral growth strategy is the application of neuromarketing and behavioral science frameworks—including the Fogg Behavior Model, cognitive bias triggers, and perception architecture—to engineer high-trust conversion paths. It focuses on decoding user intent, reducing friction, and building automated systems that naturally drive conversion and retention at national scale."
    },
    {
      question: "What industries does Kristina serve?",
      answer: "Kristina serves national brands and mid-market enterprises including SaaS, e-commerce, automotive (Ford, Volkswagen), entertainment (Disney World, Universal Studios, SeaWorld), outdoor apparel, RV manufacturing, fintech startups, and medtech companies. She works with $50M+ ARR companies seeking AI-native growth infrastructure."
    },
    {
      question: "How can I work with Kristina Shrider?",
      answer: "Kristina offers three engagement tiers: The Blueprint (forensic audit of growth infrastructure and AI-readiness), The Build (90-day execution sprint to deploy custom AI Growth Stack), and The Advisory (ongoing strategic partnership for CEOs and Founders). Services are available nationwide for organizations ready to build AI-native growth infrastructure."
    },
    {
      question: "What is Market Disruptors Agency and how does it relate to Kristina Shrider?",
      answer: "Market Disruptors AI Visibility Agency (https://marketdisruptorsagency.com), also known as Market Disruptors Agency, is the commercial agency founded by Kristina Shrider where her independent AI marketing research is applied to AI visibility, AEO (Answer Engine Optimization), and GEO (Generative Engine Optimization) systems for local service businesses. The agency operates through IKA LLC. kristinashrider.com is her personal expert authority and research hub; marketdisruptorsagency.com is the applied commercial agency."
    }
  ];

  return (
    <section className="bg-muted/20 border-t">
      <div className="container mx-auto px-6 py-16">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Frequently Asked Questions
            </h2>
            <p className="text-xl text-muted-foreground">
              Common questions about <strong className="text-foreground">AI Growth Architecture</strong>, <strong className="text-foreground">Behavioral Strategy</strong>, and <strong className="text-foreground">AEO</strong>
            </p>
          </div>

          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="glass border border-border/50 px-6"
              >
                <AccordionTrigger className="text-left hover:no-underline py-6">
                  <span className="font-semibold text-lg">{faq.question}</span>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-6 pt-2 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
